export class UserMaster {
    public ID: number;
    public HashCode: string;
    public UserName: string;
    public FirstName: string;
    public MiddleName: string;
    public LastName: string;
    public MobileNo: string;
    public EMailID: string;
    public YearID: number;
}